import axios from 'axios';
import { toast } from 'react-toastify';
import { GET_AUDIT_TRAIL_REQUEST, GET_AUDIT_TRAIL_SUCCESS, GET_AUDIT_TRAIL_ERROR } from './auditTrailActionTypes';
import auditTrailConstants from './auditTrailConstants';
import call from '../../../core/services/http';
import { BASE_URL } from '../../../core/environment/environment';
import { getToken } from '../../../shared/auth/authService';

const toastrSuccess = (msg) => toast.success(msg);
const toastrError = (msg) => toast.error(msg);

export const getAuditTrail = ({ page = 1, rowsPerPage = 10, model, actorId, action, startDate, endDate } = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_AUDIT_TRAIL_REQUEST, isLoading: true });
    const response = await call('get', auditTrailConstants.GET_AUDIT_TRAIL({ page, rowsPerPage, model, actorId, action, startDate, endDate }));
    if (response.data.status) {
      dispatch({
        type: GET_AUDIT_TRAIL_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({ type: GET_AUDIT_TRAIL_ERROR, isLoading: false, message: response.data.message });
    }
  } catch (error) {
    toastrError('Failed to load audit trail');
    dispatch({ type: GET_AUDIT_TRAIL_ERROR, isLoading: false, message: error.message });
  }
};

export const exportAuditTrail = ({ model, actorId, action, startDate, endDate } = {}) => async () => {
  try {
    const token = getToken();
    if (!token) {
      toastrError('Authentication required. Please log in again.');
      return;
    }

    const url = `${BASE_URL}${auditTrailConstants.EXPORT_AUDIT_TRAIL({ model, actorId, action, startDate, endDate })}`;
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
      timeout: 30000,
    });

    if (response.status === 200 && response.data instanceof Blob && response.data.size > 0) {
      const blob = new Blob([response.data], { type: 'text/csv' });
      const objectUrl = window.URL.createObjectURL(blob);
      const now = new Date();
      const timestamp = now.toISOString().slice(0, 10);
      const filename = `audit_trail_${timestamp}.csv`;

      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = filename;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);

      toastrSuccess(`Audit trail exported as ${filename}`);
    } else {
      toastrError('Export failed: empty response from server');
    }
  } catch (error) {
    toastrError('Failed to export audit trail');
  }
};
